// extracted by mini-css-extract-plugin
module.exports = {"fig":"figure-module--fig--1KZ35","fig__img_group":"figure-module--fig__img_group--1hRr4","fig__caption":"figure-module--fig__caption--2jX2l"};